import { NgModule } from '@angular/core';
import { InputDecimalDirective } from './input-decimal.directive';

@NgModule({
    declarations: [
        InputDecimalDirective,
    ],
    exports: [
        InputDecimalDirective,
    ],
})
export class DirectivesModule { }